import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    proposalId: Yup.number(),
    sendToClient: Yup.bool(),
    name: Yup.string().nullable(),
    desciprtion: Yup.string().nullable(),
    uploadedFile: Yup.object().nullable(),
});
